// let BACKEND_ENDPOINT = "http://localhost:3010"
let BACKEND_ENDPOINT = "https://naya-contracts-backend-ziylmcndpq-ue.a.run.app"
export {BACKEND_ENDPOINT}